// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L5sW","name":"styles_name__3MVk1","phone":"styles_phone__1x1dj"};